import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { withSizes } from 'react-sizes';
import { Router } from '../../routes';
import { selectProduct, selectDate, selectGuests, selectDateDefault } from "../../redux/actions";
import { makeUrl, Triangle, Search, Marker, slugify, getCategory, getAllProductNamesString } from '../../utils';
import { DatePicker, AmountCounter, CitySelect, DropdownContainer, SelectorModalMobile } from "../index";

import {
  HotelSearchContainer,
  HotelSearchTag,
  HotelSearchFormWrapper,
  HotelRadioListContainer,
  HotelRadioList,
  HotelRadioLabel,
  HotelFields,
  HotelFieldItem,
  HotelField,
  HotelFindButton,
} from './styles';

const mapStateToProps = state => ({
  product: state.userPreferences.product,
  city: state.userPreferences.city,
  date: state.userPreferences.date,
  guests: state.userPreferences.guests,
  priceHi: state.userPreferences.price.priceHi,
  priceLo: state.userPreferences.price.priceLo,
  distanceHi: state.userPreferences.distance.distanceHi,
  distanceLo: state.userPreferences.distance.distanceLo,
  sortType: state.userPreferences.distance.sortType,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleProductSelection: selectProduct,
  handleDateSelection: selectDate,
  handleGuestAmountChange: selectGuests,
  handleDefaultDateSelection: selectDateDefault,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class HotelSearchForm extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    product: PropTypes.string,
    city: PropTypes.instanceOf(Object),
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
    priceHi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    priceLo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    distanceHi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    distanceLo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    guests: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sortType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleProductSelection: PropTypes.func,
    handleDateSelection: PropTypes.func,
    handleDefaultDateSelection: PropTypes.func,
    handleGuestAmountChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentDropdown: null,
      loading: null,
    };
  }

  handleDropdownClick = evt => {
    const { target } = evt;
    const dropdownName = target.name;

    this.setState(prevState => ({
      currentDropdown: prevState.currentDropdown === dropdownName ? null : dropdownName,
    }));
  };

  toggleLoading = () => {
    this.setState(prevState => ({
      loading: !prevState.loading,
    }));
  };

  handleRouteChange = () => {
    const { date } = this.props;
    localStorage.setItem('searchDate', date);
  };

  componentDidMount = () => {
    Router.events.on('routeChangeStart', this.handleRouteChange);
    Router.events.on('routeChangeStart', this.toggleLoading);
  };

  componentWillUnmount = () => {
    Router.events.off('routeChangeStart', this.handleRouteChange);
    Router.events.off('routeChangeStart', this.toggleLoading);
  };

  handleCloseDropdown = () => {
    this.setState({
      currentDropdown: null,
    });
  };

  handleRadioChange = (evt) => {
    const { handleProductSelection } = this.props;
    const { target } = evt;
    const inputValue = target.closest("input").value;
    handleProductSelection(inputValue);
  };

  handleGuestChange = (amount) => {
    const { handleGuestAmountChange } = this.props;
    handleGuestAmountChange(amount);
  };

  handleDayChange = (date, initial = false) => {
    const { handleDateSelection, handleDefaultDateSelection } = this.props;
    handleDateSelection(date);

    if (initial) {
      handleDefaultDateSelection();
    }

    this.setState({
      currentDropdown: null,
    });
  };

  handleFormSubmit = evt => {
    const { product, city, date, guests, priceHi, priceLo, distanceHi, distanceLo, sortType } = this.props;
    evt.preventDefault();

    let queryObject;

    if (city.type === 'hotel') {
      queryObject = {
        product,
        hotel: `${city.label},${city.id}`,
        date: moment(date).format('YYYY-MM-DD'),
        guests,
        priceHi: priceHi || 300,
        priceLo: priceLo || 0,
        distanceHi: distanceHi || 0,
        distanceLo: distanceLo || 0,
        sortType: sortType || 3,
        experience: 'Festive,Family,Tranquil',
      };
    } else {
      queryObject = {
        product,
        market: city.label,
        date: moment(date).format('YYYY-MM-DD'),
        guests,
        priceHi: priceHi || 300,
        priceLo: priceLo || 0,
        distanceHi: distanceHi || 0,
        distanceLo: distanceLo || 0,
        sortType: sortType || 3,
        experience: 'Festive,Family,Tranquil',
      }
    }

    const query = makeUrl(queryObject);

    const url = {
      pathname: `/search`,
      query: queryObject,
    };

    const urlAs = `/s/${slugify(city.market)}/${getCategory(product)}?${query}`;

    localStorage.setItem('searchPage', JSON.stringify([
      url,
      urlAs
    ]));

    Router.pushRoute('search', {
      marketName: slugify(city.market),
      category: getCategory(product),
      ...queryObject,
    });
  };

  render() {
    const { currentDropdown, loading } = this.state;
    const { product, date, guests, isMobile } = this.props;
    const selectedAll = product === getAllProductNamesString();

    return (
      <HotelSearchContainer>
        <HotelSearchTag onSubmit={this.handleFormSubmit} autoComplete="off" className="hotel-search">
          <input autoComplete="false" type="text" hidden />
          <HotelRadioListContainer>
            <HotelRadioList onChange={this.handleRadioChange}>
              <li>
                <HotelRadioLabel isActive={selectedAll}>
                  <input hidden type="radio" name="product" value={getAllProductNamesString()} checked={product === getAllProductNamesString()} readOnly />
                  All
                </HotelRadioLabel>
              </li>
              <li>
                <HotelRadioLabel isActive={product.split(',').includes('Day Pass') && !selectedAll}>
                  <input hidden type="radio" name="product" value="Day Pass" checked={product.split(',').includes('Day Pass') && !selectedAll} readOnly />
                  Day Pass
                </HotelRadioLabel>
              </li>
              <li>
                <HotelRadioLabel isActive={product.split(',').includes('Cabana') && !selectedAll}>
                  <input hidden type="radio" name="product" value="Cabana,Daybed" checked={product.split(',').includes('Cabana') && !selectedAll} readOnly />
                  Cabana
                </HotelRadioLabel>
              </li>
              <li>
                <HotelRadioLabel isActive={product.split(',').includes('Spa Pass') && !selectedAll}>
                  <input hidden type="radio" name="product" value="Spa Pass" checked={product.split(',').includes('Spa Pass') && !selectedAll} readOnly />
                  Spa Pass
                </HotelRadioLabel>
              </li>
              <li>
                <HotelRadioLabel isActive={product.split(',').includes('Fitness Pass') && !selectedAll}>
                  <input hidden type="radio" name="product" value="Fitness Pass" checked={product.split(',').includes('Fitness Pass') && !selectedAll} readOnly />
                  Fitness Pass
                </HotelRadioLabel>
              </li>
              <li>
                <HotelRadioLabel isActive={product.split(',').includes('Beach Day Pass') && !selectedAll}>
                  <input hidden type="radio" name="product" value="Beach Day Pass" checked={product.split(',').includes('Beach Day Pass') && !selectedAll} readOnly />
                  Beach Day Pass
                </HotelRadioLabel>
              </li>
              <li>
                <HotelRadioLabel isActive={product.split(',').includes('Pool and Beach Day Pass') && !selectedAll}>
                  <input hidden type="radio" name="product" value="Pool and Beach Day Pass" checked={product.split(',').includes('Pool and Beach Day Pass') && !selectedAll} readOnly />
                  Pool and Beach Day Pass
                </HotelRadioLabel>
              </li>
              <li>
                <HotelRadioLabel isActive={product.split(',').includes('Events') && !selectedAll}>
                  <input hidden type="radio" name="product" value="Events" checked={product.split(',').includes('Events') && !selectedAll} readOnly />
                  Events
                </HotelRadioLabel>
              </li>
            </HotelRadioList>
          </HotelRadioListContainer>
          <HotelSearchFormWrapper>
            <HotelFields>
              <HotelFieldItem>
                <CitySelect />
                <Marker width={17} height={21} />
              </HotelFieldItem>
              <HotelFieldItem>
                <HotelField type="button" name="date" as="button" onClick={this.handleDropdownClick} data-date>
                  {moment(date).format('MMM D YYYY')}
                </HotelField>
                <Triangle width={12} height={9} />
                {currentDropdown === 'date' && !isMobile &&(
                  <DropdownContainer name="date" handleCloseButtonClick={this.handleDropdownClick} onClickOutside={this.handleCloseDropdown}>
                    <DatePicker selectedDate={date} handleDayClick={this.handleDayChange} />
                  </DropdownContainer>
                ) || currentDropdown === 'date' &&
                (
                  <SelectorModalMobile name="date" handleCloseButtonClick={this.handleCloseDropdown} handleClearButtonClick={() => this.handleDayChange(null, true)} total={null} title={moment(date).format('MMM DD YYYY')}>
                    <DatePicker selectedDate={date} handleDayClick={this.handleDayChange} monthsShown={12} />
                  </SelectorModalMobile>
                )}
              </HotelFieldItem>
              <HotelFieldItem>
                <HotelField type="button" name="guests" as="button" onClick={this.handleDropdownClick}>
                  {guests} guest{guests > 1 ? 's' : ''}
                </HotelField>
                <Triangle width={12} height={9} />
                {currentDropdown === 'guests' && (
                  <DropdownContainer name="guests" handleCloseButtonClick={this.handleDropdownClick} onClickOutside={this.handleCloseDropdown}>
                    <AmountCounter handleChange={this.handleGuestChange} guestAmount={guests} label="Guests" />
                  </DropdownContainer>
                )}
              </HotelFieldItem>
            </HotelFields>
            <HotelFindButton type="submit" btnType="primary" disabled={loading}>
              {loading ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="loader"
                  preserveAspectRatio="xMidYMid"
                  style={{ width: '65px', height: '20px' }}
                  viewBox="0 0 80 14"
                >
                  <g transform="translate(7 7)">
                    <circle r="7" fill="#ffffff" transform="scale(0.8984)">
                      <animateTransform
                        attributeName="transform"
                        begin="-0.375s"
                        calcMode="spline"
                        dur="1s"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        keyTimes="0;0.5;1"
                        repeatCount="indefinite"
                        type="scale"
                        values="0;1;0"
                      />
                    </circle>
                  </g>
                  <g transform="translate(27 7)">
                    <circle r="7" fill="#ffffff" transform="scale(0.59269)">
                      <animateTransform
                        attributeName="transform"
                        begin="-0.25s"
                        calcMode="spline"
                        dur="1s"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        keyTimes="0;0.5;1"
                        repeatCount="indefinite"
                        type="scale"
                        values="0;1;0"
                      />
                    </circle>
                  </g>
                  <g transform="translate(47 7)">
                    <circle r="7" fill="#ffffff" transform="scale(0.2416)">
                      <animateTransform
                        attributeName="transform"
                        begin="-0.125s"
                        calcMode="spline"
                        dur="1s"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        keyTimes="0;0.5;1"
                        repeatCount="indefinite"
                        type="scale"
                        values="0;1;0"
                      />
                    </circle>
                  </g>
                  <g transform="translate(67 7)">
                    <circle r="7" fill="#ffffff" transform="scale(0.01308)">
                      <animateTransform
                        attributeName="transform"
                        begin="0s"
                        calcMode="spline"
                        dur="1s"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        keyTimes="0;0.5;1"
                        repeatCount="indefinite"
                        type="scale"
                        values="0;1;0"
                      />
                    </circle>
                  </g>
                </svg>
              ) : (
                <Fragment>
                  Find <span>Your Day Pass</span>
                  <Search width={20} height={20} />
                </Fragment>
              )}
            </HotelFindButton>
          </HotelSearchFormWrapper>
        </HotelSearchTag>
      </HotelSearchContainer>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});


export default withSizes(mapSizesToProps)(HotelSearchForm);
